// /fisUsers DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리.

import { EditButton } from "@refinedev/mui";
import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip, OverflowTooltip } from "components/list";
import { IFisUser } from "../interfaces";
import { authMeta, resolveStatusMeta } from "./fisUsersStatus";

export const fisUsersColumns: GridColDef<IFisUser>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  {
    field: "name",
    headerName: "이름",
    width: 120,
    minWidth: 100,
  },
  { field: "loginId", headerName: "로그인ID", type: "string", width: 132, minWidth: 110 },
  {
    field: "auth",
    headerName: "권한",
    type: "string",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(authMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "phoneNumber",
    headerName: "전화번호",
    width: 140,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => {
      const phoneNumber = params.value;
      if (!phoneNumber) return null;
      // 기존 포맷 로직 유지
      const formatted = phoneNumber.replace(
        /(\d{3})(\d{4})(\d{4})/,
        "$1-$2-$3"
      );
      return <OverflowTooltip value={formatted} />;
    },
  },
  { field: "address", headerName: "주소", type: "string", width: 240, minWidth: 160 },
  { field: "sDate", headerName: "입사일", type: "string", width: 116, minWidth: 108, align: "center", headerAlign: "center" },
  { field: "createdAt", headerName: "생성일", type: "string", width: 150, minWidth: 120, align: "center", headerAlign: "center" },
  { field: "updatedAt", headerName: "수정일", type: "string", width: 236, minWidth: 180, align: "center", headerAlign: "center" },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
